// extracted by mini-css-extract-plugin
export default {"changeLink":"KP-z","disabled":"LP-z","inline":"MP-z"};